import WarningOutlined from '@ant-design/icons/WarningOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import FileOutlined from '@ant-design/icons/FileOutlined';
import LinkOutlined from '@ant-design/icons/LinkOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';

export const ACTION_CODE = {
	changeName: 'changeName',
	meeting: 'meeting',
	messaging: 'messaging',
	worth: 'worth',
	calls: 'calls',
	objection: 'objection',
	removeObjection: 'removeObjection',
	addObjection: 'addObjection',
	contacts: 'contacts',
	docs: 'docs',
	params: 'params',
	connected: 'connected',
	addCommonNumber: 'addCommonNumber',
	addPersonalContact: 'addPersonalContact',
	editContact: 'editContact',
	addContract: 'addContract',
	addDoc: 'addDoc',
	addArea: 'addArea',
	removeArea: 'removeArea',
};

export const ACTIONS_SET = [
	{
		id: ACTION_CODE.objection,
		icon: <WarningOutlined />,
		label: 'Возражения',
		lines: [
			{
				id: ACTION_CODE.addObjection,
				text: 'Добавить возражение',
			},
			{
				id: ACTION_CODE.removeObjection,
				text: 'Снять возражение',
			},
		],
	},
	{
		id: ACTION_CODE.contacts,
		icon: <UserOutlined />,
		label: 'Контакты',
		lines: [
			{
				id: ACTION_CODE.addPersonalContact,
				text: 'Добавить контактное лицо',
			},
			{
				id: ACTION_CODE.addCommonNumber,
				text: 'Добавить общий номер',
			},
			{
				id: ACTION_CODE.editContact,
				text: 'Изменить контакт',
			},
		],
	},
	{
		id: ACTION_CODE.docs,
		icon: <FileOutlined />,
		label: 'Документы',
		lines: [
			{
				id: ACTION_CODE.addContract,
				text: 'Загрузить договор',
			},
			{
				id: ACTION_CODE.addDoc,
				text: 'Загрузить другой документ',
			},
		],
	},
	{
		id: ACTION_CODE.params,
		icon: <SettingOutlined />,
		label: 'Параметры площадки',
	},
	{
		id: ACTION_CODE.connected,
		icon: <LinkOutlined />,
		label: 'Связанные площадки',
		lines: [
			{
				id: ACTION_CODE.addArea,
				text: 'Прикрепить площадку',
			},
			{
				id: ACTION_CODE.removeArea,
				text: 'Открепить площадку',
			},
		],
	},
];
